<div class="date-change-dialog" aria-labelledby="date-change-dialog-title">
  <div class="date-change-dialog-header">
    <h2 id="date-change-dialog-title" class="dialog-title">{{ title }}</h2>
    <button
      mat-icon-button
      type="button"
      class="close-button"
      aria-label="Close"
      (click)="cancel()"
    >
      <mat-icon class="close-icon material-icons">close</mat-icon>
    </button>
  </div>

  <form
    [formGroup]="form"
    class="date-change-dialog-content no-subscript-wrapper"
  >
    <div class="field-wrapper">
      <label class="field-label" for="original-date">{{
        originalDateLabel
      }}</label>
      <mat-form-field
        appearance="outline"
        class="field-input field-input-rounded field-input-readonly"
      >
        <input
          matInput
          [value]="originalDateText"
          id="original-date"
          readonly
        />
      </mat-form-field>
    </div>

    <div class="field-wrapper">
      <label class="field-label" for="reason-id">
        <span class="required">*</span>{{ reasonLabel }}
      </label>
      <mat-form-field
        appearance="outline"
        class="field-input field-input-rounded"
      >
        <mat-select
          formControlName="reasonId"
          id="reason-id"
          required
          placeholder="Select a reason"
        >
          @for (reason of reasons; track reason.id) {
            <mat-option [value]="reason.id">{{ reason.label }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <div class="field-wrapper">
      <label class="field-label" for="new-date">
        <span class="required">*</span>{{ newDateLabel }}
      </label>
      <mat-form-field
        appearance="outline"
        class="field-input field-input-rounded field-input-date"
      >
        <input
          matInput
          [matDatepicker]="picker"
          formControlName="newDate"
          id="new-date"
          required
          [min]="minDate"
        />
        <mat-datepicker-toggle matSuffix [for]="picker">
          <mat-icon matDatepickerToggleIcon class="material-icons-outlined">
            calendar_today
          </mat-icon>
        </mat-datepicker-toggle>
        <mat-datepicker #picker startView="month"></mat-datepicker>
        @if (form.get("newDate")?.hasError("matDatepickerMin")) {
          <mat-error>{{ dateErrorMessage }}</mat-error>
        }
      </mat-form-field>
    </div>

    <div class="field-wrapper">
      <label class="field-label" for="comments">{{ commentsLabel }}</label>
      <mat-form-field
        appearance="outline"
        class="field-input field-input-rounded field-input-textarea"
      >
        <textarea
          matInput
          formControlName="comments"
          id="comments"
          rows="7"
          [placeholder]="commentsPlaceholder"
        ></textarea>
      </mat-form-field>
    </div>
  </form>

  <footer class="date-change-dialog-actions">
    <button
      mat-flat-button
      color="primary"
      type="button"
      class="save-button"
      (click)="save()"
      [disabled]="form.invalid || isSaving()"
    >
      {{ saveButtonText }}
    </button>
    <button
      mat-stroked-button
      type="button"
      class="cancel-button"
      (click)="cancel()"
      [disabled]="isSaving()"
    >
      {{ cancelButtonText }}
    </button>
  </footer>
</div>
